import React from "react";
import { Row, Col } from "reactstrap";

const Filters = ({ filters, user, userOptions = [], kecamatanOptions = {}, onChange }) => {
  return (
    <Row className="mb-4">
      <Col xs={12}>
        <div className="filters-container p-3 bg-light rounded border">
          <Row>
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="searchName" className="form-label fw-bold">Cari Nama:</label>
                <input
                  type="text"
                  id="searchName"
                  name="searchName"
                  className="form-control"
                  value={filters.searchName || ""}
                  onChange={onChange}
                  placeholder="Masukkan nama lengkap"
                />
              </div>
            </Col>

           
            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="kecamatan" className="form-label fw-bold">Kecamatan:</label>
                <select
                  id="kecamatan"
                  name="kecamatan"
                  className="form-select"
                  value={filters.kecamatan}
                  onChange={onChange}
                >
                  <option value="">Pilih Kecamatan</option>
                  <option value="Semua Kecamatan">Semua Kecamatan</option>
                  {Object.keys(kecamatanOptions).map((kecamatan) => (
                    <option key={kecamatan} value={kecamatan}>
                      {kecamatan}
                    </option>
                  ))}
                </select>
              </div>
            </Col>

            <Col md={4} className="mb-3">
              {filters.kecamatan && filters.kecamatan !== "Semua Kecamatan" && (
                <div className="form-group">
                  <label htmlFor="desaKelurahan" className="form-label fw-bold">Desa/Kelurahan:</label>
                  <select
                    id="desaKelurahan"
                    name="desaKelurahan"
                    className="form-select"
                    value={filters.desaKelurahan}
                    onChange={onChange}
                  >
                    <option value="">Pilih Desa/Kelurahan</option>
                    {kecamatanOptions[filters.kecamatan].map((desa) => (
                      <option key={desa} value={desa}>
                        {desa}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </Col>

            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="kategori" className="form-label fw-bold">Kategori:</label>
                <select
                  id="kategori"
                  name="kategoriStatusRumah"
                  className="form-select"
                  value={filters.kategoriStatusRumah}
                  onChange={onChange}
                >
                  <option value="">Pilih Kategori & Status Rumah</option>
                  <option value="Rumah Layak Huni - Berpenghuni">Rumah Layak Huni - Berpenghuni</option>
                  <option value="Rumah Layak Huni - Tidak Berpenghuni">Rumah Layak Huni - Tidak Berpenghuni</option>
                  <option value="Rumah Tidak Layak Huni - Berpenghuni">Rumah Tidak Layak Huni - Berpenghuni</option>
                  <option value="Rumah Tidak Layak Huni - Tidak Berpenghuni">Rumah Tidak Layak Huni - Tidak Berpenghuni</option>
                </select>
              </div>
            </Col>
            {user && user.role === "admin" && (
              <>
               
                  <Col>
                    <div className="d-flex gap-3 mt-2">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="tanpaFoto"
                          name="tanpaFoto"
                          className="form-check-input"
                          checked={filters.tanpaFoto === "true"}
                          onChange={onChange}
                        />
                        <label className="form-check-label" htmlFor="tanpaFoto">Tanpa Foto</label>
                      </div>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="koordinatTidakValid"
                          name="koordinatTidakValid"
                          className="form-check-input"
                          checked={filters.koordinatTidakValid === "true"}
                          onChange={onChange}
                        />
                        <label className="form-check-label" htmlFor="koordinatTidakValid">Koordinat Tidak Valid</label>
                      </div>
                    </div>
                  </Col>
               
              </>
            )}


            <Col md={4} className="mb-3">
              <div className="form-group">
                <label htmlFor="searchAlamat" className="form-label fw-bold">Cari Alamat:</label>
                <input
                  type="text"
                  id="searchAlamat"
                  name="searchAlamat"
                  className="form-control"
                  value={filters.searchAlamat || ""}
                  onChange={onChange}
                  placeholder="Masukkan alamat"
                />
              </div>
            </Col>

            {user && user.role === "admin" && (
              <Col md={4} className="mb-3">
                <div className="form-group">
                  <label htmlFor="user" className="form-label fw-bold">User:</label>
                  <select
                    id="user"
                    name="user"
                    className="form-select"
                    value={filters.user}
                    onChange={onChange}
                  >
                    <option value="">Pilih User</option>
                    {userOptions.map((user) => (
                      <option key={user.id} value={user.username}>
                        {user.username}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default Filters;


